import { Chip, Stack } from '@mui/material';

export type PlanOption = {
  id: string;
  name: string;
};

type PlanInclusionChipsProps = {
  plans: PlanOption[];
  selectedPlanIds: string[];
  onToggle: (planId: string) => void;
  disabled?: boolean;
};

export const PlanInclusionChips = ({
  plans,
  selectedPlanIds,
  onToggle,
  disabled = false,
}: PlanInclusionChipsProps) => {
  return (
    <Stack direction="row" gap={1} flexWrap="wrap">
      {plans.map((plan) => {
        const isSelected = selectedPlanIds.includes(plan.id);

        return (
          <Chip
            key={plan.id}
            label={plan.name}
            clickable={!disabled}
            disabled={disabled}
            onClick={
              disabled
                ? undefined
                : () => {
                    onToggle(plan.id);
                  }
            }
            size="small"
            color={isSelected ? 'primary' : 'default'}
            variant={isSelected ? 'filled' : 'outlined'}
          />
        );
      })}
    </Stack>
  );
};
